
import { inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { Command, ConsoleLogger, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface FavouriteSwitchParams {
    readonly id: string;
    readonly value: boolean;
    readonly type: 'client' | 'product' | 'document' | 'salePattern';
}

export type FavouriteSwitchCommandResponse = {
    externalId: string,
    version: string
};

export class FavouriteSwitchCommand extends Command<FavouriteSwitchParams, FavouriteSwitchCommandResponse | undefined> { }

@CommandHandlerFor(FavouriteSwitchCommand)
@Injectable({ providedIn: 'root'})
export class FavouriteSwitchCommandHandler {
    #logger = new ConsoleLogger(this.constructor.name);
    #http = inject(Http) as HttpService;

    async handleAsync(cmd: FavouriteSwitchCommand): Promise<FavouriteSwitchCommandResponse | undefined> {
        if (!cmd?.params?.type) throw new Error('Type is required');

        const url = fillPlaceholders(this.#getUrl(cmd.params.type), { id: cmd.params?.id });
        try {
            const request = cmd.params?.value
                ? this.#http.put(url)
                : this.#http.delete(url);

            return (await request)?.data;
        } catch (err) {
            this.#logger.error(err);
        }

        return undefined;
    }

    #getUrl(type: FavouriteSwitchParams['type']): string {
        const map: Record<FavouriteSwitchParams['type'], string> = {
            client: 'clients/favourites/:id',
            product: 'products/favourites/:id',
            document: 'documents/favourites/:id',
            salePattern: 'documentTemplates/favourites/:id'
        };

        return TaggedUrl.join(map[type], [Tags.Api]);
    }
}
